module.exports = __webpack_public_path__ + "ce1b47d46b25c410c74b636d1f7a687c.svg";